// Central connector/socket type list for Vite/React/Tailwind projects
// Use this file to import connector info and icons everywhere

export const SOCKET_TYPES = [
  { id: 'connector1', label: 'CCS Type 2', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: 'connector2', label: 'Type 2', icon: '/assets/connectorSvg/img_connector_2.svg' },
  { id: 'connector3', label: 'CHAdeMO', icon: '/assets/connectorSvg/img_connector_3.svg' },
  { id: 'connector4', label: 'Type 1', icon: '/assets/connectorSvg/img_connector_4.svg' },
  { id: 'connector5', label: 'Type 1 AC', icon: '/assets/connectorSvg/img_connector_4.svg' },
  { id: 'connector6', label: '3 PIN', icon: '/assets/connectorSvg/img_connector_6.svg' },
  { id: 'connector7', label: 'GBT', icon: '/assets/connectorSvg/img_connector_7.svg' },
  { id: '7', label: 'GBT', icon: '/assets/connectorSvg/img_connector_7.svg' },
  { id: 'ccstype1', label: 'CCS Type 1', icon: '/assets/connectorSvg/img_sockets_CCS_type_1.svg' },
  { id: 'ccssae', label: 'CCS/SAE', icon: '/assets/connectorSvg/img_sockets_CCS_type_1.svg' },
  { id: 'threephase', label: 'Three Phase', icon: '/assets/connectorSvg/img_sockets_3_phase.svg' },
  { id: 'wall', label: 'Wall', icon: '/assets/connectorSvg/img_sockets_Wall.svg' },
  { id: 'j1772', label: 'J1772', icon: '/assets/connectorSvg/img_sockets_j1772.svg' },
  { id: 'ie60309', label: 'IEC60309', icon: '/assets/connectorSvg/img_sockets_iec60309.svg' },
  
  // Add more common variations
  { id: 'ccs2', label: 'CCS Type 2', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: 'ccs', label: 'CCS', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: 'ccs/sae', label: 'CCS/SAE', icon: '/assets/connectorSvg/img_sockets_CCS_type_1.svg' },
  { id: 'sae', label: 'CCS/SAE', icon: '/assets/connectorSvg/img_sockets_CCS_type_1.svg' },
  { id: 'type2', label: 'Type 2', icon: '/assets/connectorSvg/img_connector_2.svg' },
  { id: 'chademo', label: 'CHAdeMO', icon: '/assets/connectorSvg/img_connector_3.svg' },
  { id: 'type1', label: 'Type 1', icon: '/assets/connectorSvg/img_connector_4.svg' },
  { id: '3pin', label: '3 PIN', icon: '/assets/connectorSvg/img_connector_6.svg' },
  { id: '3 pin', label: '3 PIN', icon: '/assets/connectorSvg/img_connector_6.svg' },
  { id: '3 PIN', label: '3 PIN', icon: '/assets/connectorSvg/img_connector_6.svg' },
  { id: 'gbt', label: 'GBT', icon: '/assets/connectorSvg/img_connector_7.svg' },
  
  // Numeric IDs that might come from API
  { id: '1', label: 'CCS Type 2', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: '2', label: 'Type 2', icon: '/assets/connectorSvg/img_connector_2.svg' },
  { id: '3', label: 'CHAdeMO', icon: '/assets/connectorSvg/img_connector_3.svg' },
  { id: '4', label: 'Type 1', icon: '/assets/connectorSvg/img_connector_4.svg' },
  { id: '5', label: 'Type 1 AC', icon: '/assets/connectorSvg/img_connector_4.svg' },
  { id: '6', label: '3 PIN', icon: '/assets/connectorSvg/img_connector_6.svg' },
  { id: '7', label: 'GBT', icon: '/assets/connectorSvg/img_connector_7.svg' },
  { id: '8', label: 'Tesla Supercharger', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: '9', label: 'Wall Socket', icon: '/assets/connectorSvg/img_sockets_Wall.svg' },
  { id: '10', label: 'Three Phase', icon: '/assets/connectorSvg/img_sockets_3_phase.svg' },
  { id: '11', label: 'J1772', icon: '/assets/connectorSvg/img_sockets_j1772.svg' },
  { id: '12', label: 'IEC60309', icon: '/assets/connectorSvg/img_sockets_iec60309.svg' },
  { id: '13', label: 'CCS Type 1', icon: '/assets/connectorSvg/img_sockets_CCS_type_1.svg' },
  { id: '14', label: 'CCS/SAE', icon: '/assets/connectorSvg/img_sockets_CCS_type_1.svg' },
  { id: '15', label: 'Type 2 AC', icon: '/assets/connectorSvg/img_connector_2.svg' },
  { id: '16', label: 'DC Fast Charging', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: '17', label: 'AC Charging', icon: '/assets/connectorSvg/img_connector_2.svg' },
  { id: '18', label: 'Universal', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: '19', label: 'Standard AC', icon: '/assets/connectorSvg/img_connector_2.svg' },
  { id: '20', label: 'Standard DC', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: '21', label: 'Fast Charging', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: '22', label: 'Rapid Charging', icon: '/assets/connectorSvg/img_connector_1.svg' },
  
  // Common alternative names
  { id: 'combo2', label: 'CCS Type 2', icon: '/assets/connectorSvg/img_connector_1.svg' },
  { id: 'combo1', label: 'CCS Type 1', icon: '/assets/connectorSvg/img_sockets_CCS_type_1.svg' },
  { id: 'mennekes', label: 'Type 2', icon: '/assets/connectorSvg/img_connector_2.svg' },
  { id: 'yazaki', label: 'Type 1', icon: '/assets/connectorSvg/img_connector_4.svg' },
  { id: 'domestic', label: '3 PIN', icon: '/assets/connectorSvg/img_connector_6.svg' },
];

// Helper: get icon by id or label (case-insensitive)
export function getSocketIcon(connectorIdOrLabel) {
  if (!connectorIdOrLabel) return '/assets/connectorSvg/img_connector_1.svg'; // Default to CCS Type 2

  const raw = String(connectorIdOrLabel).toLowerCase().trim();
  const normalized = raw.replace(/[\s\-/_]/g, ''); // Remove spaces, dashes, slashes, underscores


  // Try exact match first
  let found = SOCKET_TYPES.find(s => 
    s.id.toLowerCase() === raw ||
    s.label.toLowerCase() === raw
  );

  // Try normalized match if exact failed
  if (!found) {
    found = SOCKET_TYPES.find(s =>
      s.id.replace(/[\s\-/_]/g, '').toLowerCase() === normalized ||
      s.label.replace(/[\s\-/_]/g, '').toLowerCase() === normalized
    );
  }

  // Try partial matching for common patterns
  if (!found) {
    if (normalized.includes('ccs') || normalized.includes('combo')) {
      if (normalized.includes('sae') || normalized.includes('/sae')) {
        found = SOCKET_TYPES.find(s => s.id === 'ccssae');
      } else if (normalized.includes('1') || normalized.includes('type1')) {
        found = SOCKET_TYPES.find(s => s.id === 'ccstype1');
      } else {
        found = SOCKET_TYPES.find(s => s.id === 'connector1'); // CCS Type 2 default
      }
    } else if (normalized.includes('sae')) {
      found = SOCKET_TYPES.find(s => s.id === 'ccssae');
    } else if (normalized.includes('type2') || normalized.includes('mennekes')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector2');
    } else if (normalized.includes('chademo') || normalized.includes('cha')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector3');
    } else if (normalized.includes('type1') || normalized.includes('yazaki') || normalized.includes('j1772')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector4');
    } else if (normalized.includes('3pin') || normalized.includes('domestic') || normalized.includes('pin') || raw.includes('3 pin')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector6');
    } else if (normalized.includes('gbt') || normalized.includes('gb/t')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector7');
    }
  }

  if (!found) {
  }

  const result = found?.icon || '/assets/connectorSvg/img_connector_1.svg'; // Default to CCS Type 2
  return result;
}

// Helper: get connector info (both icon and display name) by id or label
export function getConnectorInfo(connectorIdOrLabel) {
  if (!connectorIdOrLabel) {
    return {
      icon: '/image/connectorSvg/img_connector_1.svg',
      displayName: 'CCS Type 2'
    };
  }

  const raw = String(connectorIdOrLabel).toLowerCase().trim();
  const normalized = raw.replace(/[\s\-/_]/g, ''); // Remove spaces, dashes, slashes, underscores


  // Try exact match first (including numeric IDs)
  let found = SOCKET_TYPES.find(s => 
    s.id.toLowerCase() === raw ||
    s.id === raw || // Exact match for numeric strings
    s.label.toLowerCase() === raw
  );

  // Try normalized match if exact failed
  if (!found) {
    found = SOCKET_TYPES.find(s =>
      s.id.replace(/[\s\-/_]/g, '').toLowerCase() === normalized ||
      s.label.replace(/[\s\-/_]/g, '').toLowerCase() === normalized
    );
  }

  // Try partial matching for common patterns
  if (!found) {
    if (normalized.includes('ccs') || normalized.includes('combo')) {
      if (normalized.includes('sae') || normalized.includes('/sae')) {
        found = SOCKET_TYPES.find(s => s.id === 'ccssae');
      } else if (normalized.includes('1') || normalized.includes('type1')) {
        found = SOCKET_TYPES.find(s => s.id === 'ccstype1');
      } else {
        found = SOCKET_TYPES.find(s => s.id === 'connector1'); // CCS Type 2 default
      }
    } else if (normalized.includes('sae')) {
      found = SOCKET_TYPES.find(s => s.id === 'ccssae');
    } else if (normalized.includes('type2') || normalized.includes('mennekes')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector2');
    } else if (normalized.includes('chademo') || normalized.includes('cha')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector3');
    } else if (normalized.includes('type1') || normalized.includes('yazaki') || normalized.includes('j1772')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector4');
    } else if (normalized.includes('3pin') || normalized.includes('domestic') || normalized.includes('pin') || raw.includes('3 pin')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector6');
    } else if (normalized.includes('gbt') || normalized.includes('gb/t')) {
      found = SOCKET_TYPES.find(s => s.id === 'connector7');
    }
  }

  if (!found) {
    return {
      icon: '/assets/connectorSvg/img_connector_1.svg',
      displayName: 'CCS Type 2'
    };
  }

  return {
    icon: found.icon,
    displayName: found.label
  };
}
